import React from "react";
import moment from "moment";

/**
 * Shows the company-wide praise message on the dashboard (all authenticated users).
 */
const DEFAULT_LABEL = "Team praise";

const DashboardPraiseBanner = ({ message, praiseLabel, authorName, updatedAt }) => {
    const text = typeof message === "string" ? message.trim() : "";
    if (!text) return null;
    const labelText =
        typeof praiseLabel === "string" && praiseLabel.trim()
            ? praiseLabel.trim()
            : DEFAULT_LABEL;
    const publishedAt = updatedAt && moment(updatedAt).isValid() ? moment(updatedAt) : null;
    // Banner is only visible for 24 hours from publish time.
    if (publishedAt && moment().diff(publishedAt, "hours", true) > 24) return null;

    const when =
        publishedAt
            ? publishedAt.format("D MMM YYYY, h:mm A")
            : null;
    const by = authorName && String(authorName).trim() ? String(authorName).trim() : null;

    return (
        <div className="dashboard-praise-banner" role="region" aria-label={labelText}>
            <div className="dashboard-praise-banner-confetti" aria-hidden="true">
                {Array.from({ length: 12 }).map((_, idx) => (
                    <span
                        key={`praise-confetti-${idx}`}
                        className="dashboard-praise-confetti-piece"
                        style={{ "--piece-index": idx }}
                    />
                ))}
            </div>
            <div className="dashboard-praise-banner-label">
                {labelText}
            </div>
            <p className="dashboard-praise-banner-message">{text}</p>
            {/* {(when || by) && (
                <div className="dashboard-praise-banner-meta">
                    {by ? <span>From {by}</span> : null}
                    {by && when ? <span className="dashboard-praise-banner-dot"> · </span> : null}
                    {when ? <span>{when}</span> : null}
                </div>
            )} */}
        </div>
    );
};

export default DashboardPraiseBanner;
